<template>
  <v-row id="course-wheel">
    <div class="col-12">
      <div class="course-wheel">
        <apexchart
          :options="radialBarChart.chartOptions"
          :series="series"
          type="radialBar"
          width="400"
          height="400"
        />
        <div class="text-left">
          <h3>Enrolled Courses: {{ total_courses }}</h3>
          <h3 class="completed">Completed: {{ total_completed_courses }}</h3>
          <h3 class="inprogress">
            In Progress: {{ total_in_progress_courses }}
          </h3>
          <h3 class="notstarted">Not Started: {{ notStartedCourses }}</h3>
        </div>
      </div>
    </div>
    <div class="col-12">
      <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
      <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
      <v-data-table
        :headers="headers"
        :options.sync="options"
        :server-items-length="serverItemsLength"
        v-show="!loading"
        :items="courses"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.test_score="{ item }">
          <span v-if="!item.has_test">N/A</span>
          <span v-else>
            <span v-if="item.test_complete"> {{ item.test_score }}% </span>
            <span v-else>T.B.C</span>
          </span>
        </template>
        <template v-slot:item.progress="{ item }">
          {{ item.progress }}%
        </template>
        <template v-slot:item.has_test="{ item }">
          <span v-if="!item.has_test">N/A</span>
          <span v-else>
            <span v-if="item.test_complete">
              <span v-if="item.test_passed">
                <v-icon color="green">fa-check</v-icon>
              </span>
              <span v-else>
                <v-icon color="red">fa-times</v-icon>
              </span>
            </span>
            <span v-else> T.B.C </span>
          </span>
        </template>

        <!-- 5: Take Test / View Course -->
        <template v-slot:item.id="{ item }">
          <!-- 1: Take Course -->
          <div v-if="item.state == 1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  if="item.state == 2"
                  v-on="on"
                  color="secondary"
                  class="ml-1"
                  :to="'/courses/player/' + item.course_id"
                  text
                  small
                >
                  <v-icon small>fa-arrow-right</v-icon>
                </v-btn>
              </template>
              <span>Start Course</span>
            </v-tooltip>
          </div>
          <div v-else-if="item.state == 2">
            <!-- 2: Continue Course -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  if="item.state == 2"
                  v-on="on"
                  color="secondary"
                  class="ml-1"
                  :to="'/courses/player/' + item.course_id"
                  text
                  small
                >
                  <v-icon small>fa-circle-notch</v-icon>
                </v-btn>
              </template>
              <span>Continue Course</span>
            </v-tooltip>
          </div>
          <div v-else-if="item.state == 3">
            <!-- 3: Download Cert / View Course -->
            <v-tooltip v-if="item.has_test && item.test_passed" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  if="item.state == 2"
                  v-on="on"
                  color="secondary"
                  class="ml-1"
                  text
                  small
                  @click="generatePDF(item.certificate_url)"
                >
                  <v-icon small>fa-certificate</v-icon>
                </v-btn>
              </template>
              <span>Download Certificate</span>
            </v-tooltip>
            <v-tooltip v-if="!item.has_test" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  if="item.state == 2"
                  v-on="on"
                  color="secondary"
                  class="ml-1"
                  text
                  small
                  @click="generatePDF(item.certificate_url)"
                >
                  <v-icon small>fa-certificate</v-icon>
                </v-btn>
              </template>
              <span>Download Certificate</span>
            </v-tooltip>
          </div>
          <div v-else-if="item.state == 5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  if="item.state == 2"
                  v-on="on"
                  color="secondary"
                  class="ml-1"
                  @click="showTest(item.course_id)"
                  text
                  small
                >
                  <v-icon small>fa-list-ul</v-icon>
                </v-btn>
              </template>
              <span>Take Test</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  if="item.state == 2"
                  v-on="on"
                  color="secondary"
                  class="ml-1"
                  :to="'/courses/player/' + item.course_id"
                  text
                  small
                >
                  <v-icon small>fa-circle-notch</v-icon>
                </v-btn>
              </template>
              <span>Continue Course</span>
            </v-tooltip>
          </div>
          <div v-else>0</div>

          <!--<v-btn color="secondary">View Course</v-btn>
          <v-btn color="secondary">Contine</v-btn>-->
          <!--<v-btn v-else :to="'/courses/player/' + item.course_id" color="secondary">View</v-btn>-->
          <!--<v-btn :ref="'cert-loading-'+item.id" class="ml-1" @click.prevent="generatePDF(item.id)" color="secondary">Certificate</v-btn>-->
        </template>
      </v-data-table>
    </div>
  </v-row>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import userAPI from '@/api/user.js';
import courseAPI from '@/api/course.js';
import Test from '@/components/authenticated/courses/Test';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'ActivityWidget',
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      headers: [
        { text: 'Course Title', value: 'title', sortable: false },
        { text: 'Status', value: 'state_text', sortable: false },
        {
          text: 'Date Enrolled',
          value: 'enrolled_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Started',
          value: 'start_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Completed',
          value: 'complete_date_formatted',
          sortable: false,
        },
        { text: 'Progress %', value: 'progress', sortable: false },
        { text: 'Deadline', value: 'deadline_formatted', sortable: false },
        { text: 'Test Score', value: 'test_score', sortable: false },
        { text: 'Passed Test', value: 'has_test', sortable: false },

        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      courses: [],
      loading: false,
      pagination: {},
      options: {},
      id: this.$route.params.id,
      radialBarChart: {
        series: this.series,
        chartOptions: {
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '18px',
                },
                value: {
                  fontSize: '16px',
                },
                total: {
                  show: true,
                  label: 'Courses',
                  formatter: function () {
                    return this.total;
                  },
                },
              },
            },
          },
          labels: ['Not Started', 'In progress', 'Completed'],
        },
      },
    };
  },
  props: {
    total_courses: {
      type: Number,
      default: 0,
    },
    total_in_progress_courses: {
      type: Number,
      default: 0,
    },
    total_completed_courses: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    notStartedCourses: function () {
      return (
        this.total_courses -
        this.total_in_progress_courses -
        this.total_completed_courses
      );
    },
    notStartedPercentage: function () {
      return this.getWholePercent(this.notStartedCourses, this.total_courses);
    },
    inProgessPercentage: function () {
      return this.getWholePercent(
        this.total_in_progress_courses,
        this.total_courses
      );
    },
    completedPercentage: function () {
      return this.getWholePercent(
        this.total_completed_courses,
        this.total_courses
      );
    },
    total: function () {
      return this.total_courses;
    },
    series: function () {
      return [
        this.notStartedPercentage,
        this.inProgessPercentage,
        this.completedPercentage,
      ];
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getWholePercent(percentFor, percentOf) {
      //let precision = Math.pow(10, 1);
      let num = (percentFor / percentOf) * 100;
      return Math.round(num);
    },
    showTest(id) {
      courseAPI
        .getCourse(id, '?include=enrolled,videos,documents,test')
        .then((response) => {
          this.$store.dispatch('setCoursePlayer', response.data.data);
          this.$showPanel({
            component: Test,
            props: {
              course: response.data.data,
            },
            openOn: 'right',
          });
        });
    },
    setEventBus() {
      EventBus.$on('ANSWERS_SUBMITTED', (payload) => {
        this.getCourses();
      });
    },
    generatePDF(url) {
      if (url != null) {
        window.open(url, '_blank');
      }
    },
    getCourses() {
      this.loading = true;
      userAPI.getUserCourses(this.params, this.id).then((resp) => {
        this.courses = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
  },
};
</script>
<style>
.completed {
  color: #ffaf19;
}
.inprogress {
  color: #00e396;
}
.notstarted {
  color: #008efb;
}
</style>
